module.exports = __webpack_public_path__ + "static/media/linkedin-icon-newpurple.ff7f5e9a.svg";